/**
 * @flow
 * @relayHash 8ac1bd9be88ba3b691cda75f1edf6a5e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type order_viewer$ref = any;
export type order_QueryVariables = {|
  invoice_number?: ?number,
  isDefaultRoute: boolean,
|};
export type order_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: order_viewer$ref,
  |},
|};
*/


/*
query order_Query(
  $invoice_number: Int
  $isDefaultRoute: Boolean!
) {
  viewer {
    ...order_viewer
    id
  }
}

fragment order_viewer on Viewer {
  my_orders {
    id
    currency_code
    currency_rate
    invoice_number
    order_date
    payment_due_date
    payment_status
    total
    project_details {
      brand
      product
      reference
      po_number
      notes
    }
  }
  order(invoice_number: $invoice_number) @skip(if: $isDefaultRoute) {
    id
    currency_code
    currency_rate
    discount
    invoice_number
    order_date
    payment_due_date
    payment_received_date
    payment_status
    subtotal
    total
    license_line_items {
      id
      amount
      discount_amount
      track {
        id
        internal_id
        title
        added_to_cart
        slug
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        artist {
          id
          name
          slug
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
        }
        terms {
          edges {
            node {
              id
              is_highlighted
              name
              parent_id
              taxonomy {
                id
                internal_id
                name
              }
            }
          }
        }
      }
      license {
        id
        usages {
          id
          license_id
          air_date
          components {
            id
            component_id
            name
            type
          }
        }
      }
    }
    general_line_items {
      id
      description
      amount
      discount_amount
    }
    promo_code_line_item {
      id
      code
      discount_type
      discount_type_amount
    }
    tax_line_items {
      id
      priority
      tax_name
      rate
      amount
    }
    licensee_address {
      id
      type
      name
      company
      company_type_id
      company_type {
        id
        name
      }
      line_1
      line_2
      city
      postal_code
      subdivision_code
      country_code
    }
    billing_address {
      id
      type
      name
      company
      company_type_id
      company_type {
        id
        name
      }
      line_1
      line_2
      city
      postal_code
      subdivision_code
      country_code
    }
    project_details {
      brand
      product
      reference
      po_number
      notes
    }
    authorized_representative {
      name
      email
      phone
      role_id
      role {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "invoice_number",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isDefaultRoute",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency_code",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency_rate",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "invoice_number",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "order_date",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "payment_due_date",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "payment_status",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "total",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "project_details",
  "storageKey": null,
  "args": null,
  "concreteType": "ProjectDetails",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "brand",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "product",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "reference",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "po_number",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "notes",
      "args": null,
      "storageKey": null
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "discount_amount",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "internal_id",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v1,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    },
    v14,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v17 = [
  v1,
  v16
],
v18 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_1",
    "args": null,
    "storageKey": null
  },
  v1,
  v16,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "company",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "company_type_id",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "company_type",
    "storageKey": null,
    "args": null,
    "concreteType": "CompanyType",
    "plural": false,
    "selections": v17
  },
  v14,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "line_2",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "subdivision_code",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "country_code",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "order_Query",
  "id": null,
  "text": "query order_Query(\n  $invoice_number: Int\n  $isDefaultRoute: Boolean!\n) {\n  viewer {\n    ...order_viewer\n    id\n  }\n}\n\nfragment order_viewer on Viewer {\n  my_orders {\n    id\n    currency_code\n    currency_rate\n    invoice_number\n    order_date\n    payment_due_date\n    payment_status\n    total\n    project_details {\n      brand\n      product\n      reference\n      po_number\n      notes\n    }\n  }\n  order(invoice_number: $invoice_number) @skip(if: $isDefaultRoute) {\n    id\n    currency_code\n    currency_rate\n    discount\n    invoice_number\n    order_date\n    payment_due_date\n    payment_received_date\n    payment_status\n    subtotal\n    total\n    license_line_items {\n      id\n      amount\n      discount_amount\n      track {\n        id\n        internal_id\n        title\n        added_to_cart\n        slug\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        artist {\n          id\n          name\n          slug\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n        }\n        terms {\n          edges {\n            node {\n              id\n              is_highlighted\n              name\n              parent_id\n              taxonomy {\n                id\n                internal_id\n                name\n              }\n            }\n          }\n        }\n      }\n      license {\n        id\n        usages {\n          id\n          license_id\n          air_date\n          components {\n            id\n            component_id\n            name\n            type\n          }\n        }\n      }\n    }\n    general_line_items {\n      id\n      description\n      amount\n      discount_amount\n    }\n    promo_code_line_item {\n      id\n      code\n      discount_type\n      discount_type_amount\n    }\n    tax_line_items {\n      id\n      priority\n      tax_name\n      rate\n      amount\n    }\n    licensee_address {\n      id\n      type\n      name\n      company\n      company_type_id\n      company_type {\n        id\n        name\n      }\n      line_1\n      line_2\n      city\n      postal_code\n      subdivision_code\n      country_code\n    }\n    billing_address {\n      id\n      type\n      name\n      company\n      company_type_id\n      company_type {\n        id\n        name\n      }\n      line_1\n      line_2\n      city\n      postal_code\n      subdivision_code\n      country_code\n    }\n    project_details {\n      brand\n      product\n      reference\n      po_number\n      notes\n    }\n    authorized_representative {\n      name\n      email\n      phone\n      role_id\n      role {\n        id\n        name\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "order_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "order_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "order_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "my_orders",
            "storageKey": null,
            "args": null,
            "concreteType": "Order",
            "plural": true,
            "selections": [
              v1,
              v2,
              v3,
              v4,
              v5,
              v6,
              v7,
              v8,
              v9
            ]
          },
          v1,
          {
            "kind": "Condition",
            "passingValue": false,
            "condition": "isDefaultRoute",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "order",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "invoice_number",
                    "variableName": "invoice_number",
                    "type": "Int"
                  }
                ],
                "concreteType": "Order",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "subtotal",
                    "args": null,
                    "storageKey": null
                  },
                  v1,
                  v3,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "discount",
                    "args": null,
                    "storageKey": null
                  },
                  v4,
                  v5,
                  v6,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "payment_received_date",
                    "args": null,
                    "storageKey": null
                  },
                  v7,
                  v2,
                  v8,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "license_line_items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LicenseLineItem",
                    "plural": true,
                    "selections": [
                      v1,
                      v10,
                      v11,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "track",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TrackSearchResult",
                        "plural": false,
                        "selections": [
                          v1,
                          v12,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "title",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "added_to_cart",
                            "args": null,
                            "storageKey": null
                          },
                          v13,
                          v15,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "artist",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Artist",
                            "plural": false,
                            "selections": [
                              v1,
                              v16,
                              v13,
                              v15
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "terms",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TaxonomyTermConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TaxonomyTermEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TaxonomyTerm",
                                    "plural": false,
                                    "selections": [
                                      v1,
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "is_highlighted",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      v16,
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "parent_id",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "taxonomy",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Taxonomy",
                                        "plural": false,
                                        "selections": [
                                          v1,
                                          v12,
                                          v16
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "license",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StandardLicense",
                        "plural": false,
                        "selections": [
                          v1,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "usages",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "StandardLicenseUsage",
                            "plural": true,
                            "selections": [
                              v1,
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "license_id",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "air_date",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "components",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "StandardLicenseUsageComponent",
                                "plural": true,
                                "selections": [
                                  v1,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "component_id",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v16,
                                  v14
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "general_line_items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "GeneralLineItem",
                    "plural": true,
                    "selections": [
                      v1,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "description",
                        "args": null,
                        "storageKey": null
                      },
                      v10,
                      v11
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "promo_code_line_item",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PromoCodeLineItem",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "code",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "discount_type",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "discount_type_amount",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tax_line_items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TaxLineItem",
                    "plural": true,
                    "selections": [
                      v1,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "priority",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "tax_name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "rate",
                        "args": null,
                        "storageKey": null
                      },
                      v10
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "licensee_address",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OrderAddress",
                    "plural": false,
                    "selections": v18
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "billing_address",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OrderAddress",
                    "plural": false,
                    "selections": v18
                  },
                  v9,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "authorized_representative",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AuthorizedRepresentative",
                    "plural": false,
                    "selections": [
                      v16,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "email",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "phone",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "role_id",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "role",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "RepresentativeRole",
                        "plural": false,
                        "selections": v17
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = '413235e38e764921e234c0c8dc999721';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/order_Query.graphql.js